import { ScreeningMatchResult } from "~/graphql/supergraphEnums";
import { PEP_CATEGORY_LABELS, PEP_EXPOSURE_EMPTY_DISPLAY } from "./constants";

export type PepExposureMatch = {
  result?: string | null;
  pepCategory?: number | null;
};

export type PepExposureProfile = {
  screeningMatches?: PepExposureMatch[] | null;
  screeningRecord?: unknown;
};

const getMatchesFromRecord = (record: unknown): PepExposureMatch[] => {
  if (!record || typeof record !== "object" || !("matches" in record)) return [];
  const { matches } = record as { matches?: PepExposureMatch[] | null };
  return matches ?? [];
};

export const getPepMatches = (
  profile: PepExposureProfile | null | undefined,
): PepExposureMatch[] =>
  profile?.screeningMatches ?? getMatchesFromRecord(profile?.screeningRecord);

export const collatePepExposure = (matches: PepExposureMatch[]): number | null => {
  const categorized = matches
    .filter(
      (match) => match.result === ScreeningMatchResult.TrueMatch && match.pepCategory != null,
    )
    .map((match) => match.pepCategory as number);
  if (!categorized.length) return null;
  return Math.min(...categorized);
};

export const getProfilePepExposure = (
  profile: PepExposureProfile | null | undefined,
): number | null => collatePepExposure(getPepMatches(profile));

export const getCasePepExposure = (
  complianceCase:
    | {
        investingProfile?: PepExposureProfile | null;
        profiles?: Array<PepExposureProfile | null> | null;
      }
    | null
    | undefined,
): number | null => {
  const profiles = [complianceCase?.investingProfile, ...(complianceCase?.profiles ?? [])];
  return collatePepExposure(profiles.flatMap(getPepMatches));
};

export const formatPepExposure = (pepCategory: number | null | undefined): string => {
  if (pepCategory == null) return PEP_EXPOSURE_EMPTY_DISPLAY;
  return PEP_CATEGORY_LABELS[pepCategory] ?? PEP_EXPOSURE_EMPTY_DISPLAY;
};
